import OfflineConnector from "slotworks/server/connectors/offline-connector";
import { PrecannedResultList } from "slotworks/server/precanned/precanned-result-list";
import Contract from "slotworks/utils/contract";

class OfflineForceResults implements PrecannedResultList {

    private results: Map<string, number> = new Map<string, number>();

    public addResult(key: string, jumpToIndex: number) {
        this.results.set(key, jumpToIndex);
    }

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            const names: string[] = [];

            this.results.forEach((index, name) => {
                names.push(name.split("_").join(" "));
            });

            resolve(names);
        });
    }

    public force(id: string): Contract<void> {
        return new Contract<void>((resolve) => {
            OfflineConnector.setCurrentResult(this.results.get(id.split(" ").join("_")));

            resolve(null);
        });
    }
}

export default new OfflineForceResults();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/server/precanned/offline-precanned-results.ts